import VimeoPlayer from '../components/VimeoPlayer';

export default class VimeoVideos {
	constructor() {
		document.addEventListener('bless', (e) => {
			if (!e.target) {
				return;
			}

			this.createVideos(e.target);
		});
	}

	createVideos(el) {
		el.querySelectorAll('[data-video-player]').forEach((filter) => {
			new VimeoPlayer(filter);
		});
	}
}
